<a class="item">
    <div class="item__content">
        <div class="imageWrapper">
            <img [src]="iconUrl" alt="image" class="imaged w64" *ngIf="isImage">
            <ion-icon name="{{iconUrl}}" class="{{iconUrl}}" *ngIf="!isImage"></ion-icon>          
        </div>
        <div class="in">
            <div>                
                <ng-content></ng-content>
            </div>
                <ng-content select="[badge]"></ng-content>
        </div>
    </div>

    <ng-container *ngIf="isForward==true">
        <ion-icon name="chevron-forward-outline" class="forward"></ion-icon>
    </ng-container>

</a>